import { ApplicationConfigurationRequiredDocumentType, SettingParameterUnit } from '@zg-rentals/ts-capps-client';

export type RequiredDocumentCopy = {
  label: string;
  description: string;
};

export const REQUIRED_DOCUMENT_COPY: Record<ApplicationConfigurationRequiredDocumentType, RequiredDocumentCopy> = {
  [ApplicationConfigurationRequiredDocumentType.BANK_STATEMENTS]: {
    label: 'Bank statements',
    description: 'Statements from the account where income is deposited',
  },
  [ApplicationConfigurationRequiredDocumentType.CPA_ATTESTATION]: {
    label: 'CPA attestation',
    description: 'A signed letter from a certified public accountant that confirms income',
  },
  [ApplicationConfigurationRequiredDocumentType.EMPLOYMENT_VERIFICATION_LETTER]: {
    label: 'Employment verification or offer letter',
    description: 'A letter from the employer that confirms employment and salary',
  },
  [ApplicationConfigurationRequiredDocumentType.FORM_1099]: {
    label: 'Form 1099',
    description: 'Tax forms that report income earned as a contractor or freelancer',
  },
  [ApplicationConfigurationRequiredDocumentType.PAY_STUBS]: {
    label: 'Pay stubs',
    description: 'Pay stubs from the current employer that show income',
  },
  [ApplicationConfigurationRequiredDocumentType.PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT]: {
    label: 'Proof of college acceptance or enrollment',
    description: 'An acceptance or enrollment letter from a college or a university',
  },
  [ApplicationConfigurationRequiredDocumentType.PROOF_OF_OTHER_INCOME]: {
    label: 'Proof of government benefits or other income',
    description:
      'Includes Social Security benefit, Supplemental Security Income (SSI), disability payment, alimony, financial aid, and child support',
  },
  [ApplicationConfigurationRequiredDocumentType.STATEMENT_OF_ASSETS]: {
    label: 'Statement of assets',
    description: 'A statement of savings, investments, or other assets',
  },
  [ApplicationConfigurationRequiredDocumentType.TAX_RETURNS]: {
    label: 'Personal or business tax returns',
    description: 'Filed personal or business tax returns',
  },
  [ApplicationConfigurationRequiredDocumentType.W2]: {
    label: 'Form W-2',
    description: 'Tax forms from the employer that report annual wages',
  },
};

const UNIT_LABELS: Record<SettingParameterUnit, { plural: string; singular: string }> = {
  [SettingParameterUnit.MONTHS]: { plural: 'months', singular: 'month' },
  [SettingParameterUnit.TAX_YEARS]: { plural: 'tax years', singular: 'tax year' },
};

export function formatRequirement(
  parameterQuantity?: number,
  parameterUnit?: SettingParameterUnit,
): string | undefined {
  if (parameterQuantity == null || parameterUnit == null) {
    return undefined;
  }
  const { plural, singular } = UNIT_LABELS[parameterUnit];
  return parameterQuantity === 1 ? `Most recent ${singular}` : `Most recent ${parameterQuantity} ${plural}`;
}
